import { _ as __rest } from './tslib.es6-2af8cb53.js';
import { h } from './index-16dc7dde.js';

const isRoutingDisabled = (props) => {
  return 'url' in props && !!props.url;
};
const RouterLinkView = (props, children) => {
  var _a;
  if (isRoutingDisabled(props)) {
    return (h("a", { class: props.linkClassName, href: props.url, target: (_a = props.target) !== null && _a !== void 0 ? _a : '_self' }, children));
  }
  const { linkClassName, routerClassName } = props, routerProps = __rest(props, ["linkClassName", "routerClassName"]);
  return (h("pes-router-link", Object.assign({ key: props.pageId, class: routerClassName }, routerProps),
    h("a", { class: linkClassName, href: "#" }, children)));
};

export { RouterLinkView as R };
